import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { CognitoIdentityServiceProvider } from 'aws-sdk';
import React from 'react';

interface Props {
    group: CognitoIdentityServiceProvider.GroupType;
    onDelete: (group: CognitoIdentityServiceProvider.GroupType) => void;
    onClose: () => void;
}

export default function DeleteGroupDialog(props: Props) {

    return (
        <React.Fragment>
            <Dialog open={true} fullWidth={true} onClose={props.onClose} aria-labelledby="form-dialog-title" maxWidth={"md"} >
                <DialogTitle>Delete Group</DialogTitle>
                <DialogContent>
                    Are you sure you wish to delete group {props.group.GroupName}?
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => {
                        props.onDelete(props.group);
                        props.onClose();
                    }} color="primary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
